










































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';
import defaultAppImg from './assets/images/apps/app_0.svg';
import { APPNAME_ID_MAP } from './assets/images/apps/name-id-map';

const cssPrefix = 'sw-app-icon';

const appIdSet = new Set(APPNAME_ID_MAP.values());

@Component
export default class SwAppIcon extends SwExtendedVue {
  @Prop({ type: Number })
  id: number;

  @Prop({ type: String })
  name: string;

  @Prop({ type: [String, Number], default: 'medium' })
  width: string | number;

  @Prop({ type: Number, default: undefined })
  height: number;

  @Prop({ type: Boolean, default: false })
  bottomAlign: boolean;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  @Prop({ type: Boolean, default: false })
  clickable: boolean;

  cssPrefix = cssPrefix;

  imgSrc: any = defaultAppImg;

  get effectiveId() {
    if (this.id !== undefined) {
      return appIdSet.has(this.id) ? this.id : 0;
    }
    if (this.name !== undefined) {
      const id = APPNAME_ID_MAP.get(this.name);
      return id || 0;
    }
    return 0;
  }

  get numericWidth(): number {
    if (typeof this.width === 'number') {
      return this.width;
    }
    return utilService.sizeMap[this.width] || utilService.sizeMap['medium'];
  }

  get effectiveHeight(): number | undefined {
    if (typeof this.height === 'number') {
      return this.height;
    }
    return undefined;
  }

  get imgStyle(): CSSStyleOptions {
    return {
      width: `${this.numericWidth}px`,
      height: typeof this.effectiveHeight === 'number' ? `${this.effectiveHeight}px` : undefined,
    };
  }

  get imgName() {
    return `app_${this.effectiveId}.svg`;
  }

  @Watch('effectiveId', { immediate: true })
  private onAppIdChange() {
    if (this.effectiveId === 0) {
      this.imgSrc = defaultAppImg;
      return;
    }

    import(
      /* webpackChunkName: "[request]" */
      `./assets/images/apps/${this.imgName}`// tslint:disable-line
    )
    .then(({ default: loadedImg }) => {
      this.imgSrc = loadedImg;
    })
    .catch((e: any) => {
      console.error(`Cannot load app image ${this.imgName}`, e);
      this.imgSrc = defaultAppImg;
    });
  }
}
